<template>
  <div id="app">
    <!-- 导航区域 -->
    <!--    <LuffyHeader />-->

    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
    <div>
      <template>
        <el-backtop><img src="../static/img2/fanhui.png" alt=""></el-backtop>
      </template>
    </div>
  </div>
</template>

<script>
import LuffyHeader from '@/components/Common/LuffyHeader'
import {getTopDomain} from "./utils";
window.onbeforeunload=onclose;

export default {
  name: 'App',

  components: {
    // LuffyHeader
  },
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true
    }
  },

    mounted(){
        this.getSchoolInfo()
     // window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))
     //  window.addEventListener('unload', e => this.unloadHandler(e))
    },
    // destroyed(){
    // window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e))
    //   window.removeEventListener('unload', e => this.unloadHandler(e))
    // },

  methods: {

    // beforeunloadHandler(){
    //     this._beforeUnload_time=new Date().getTime()
    // },
    // unloadHandler(e){
    //   console.log(e)
    //     this._gap_time=new Date().getTime()-this._beforeUnload_time
    //     // debugger
    //     //判断是窗口关闭还是刷新
    //     if(this._gap_time<=4){
    //       //如果是登录状态，关闭窗口前，移除用户
    //           this.$cookies.remove('token');
    //     }
    // },
      getSchoolInfo(){
          var domain_name=getTopDomain()
          if (this.$cookies.get('token')) {
              this.$http.schoolInfo({school_id:this.$store.getters.getUserInfo.school_id}).then(res => {
                  this.$store.commit("SetSchoolInfo", res.data);
              })
          }else
          {
              this.$http.schoolInfo({domain_name:domain_name}).then(res => {
                  this.$store.commit("SetSchoolInfo", res.data);
              })
          }

      },
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  },
  '$route.path': function (newVal, oldVal) {
    // console.log(newVal)

  },
  created() {
    // 在页面加载时读取localStorage
    if (localStorage.getItem('store')) {
      this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(localStorage.getItem('store'))))
    }
    // 在页面刷新时将store保存到localStorage里
    window.addEventListener('beforeunload', () => {
      localStorage.setItem('store', JSON.stringify(this.$store.state))
    })
  }
}
</script>

<style scoped lang="less">
@import "../static/fonts/stylemain/style.less";
page{
  background-color: #212129;
  padding: 0;
}

@media screen and (max-width: 768px) {
 #app{
 width: 100%;
 height: 100%;
overflow-x: hidden;
 }

}
@media screen and (min-width: 768px) {
  #app{
 width: 100%;
 height: 100vh;
background-color: @bg3;
 }
}

</style>



// WEBPACK FOOTER //
// src/App.vue